const state={
    handled:false,
}

const getters={
    handled:(state)=>state.handled
}

const mutations = {
    updateHandled:(state,flag)=>{
        state.handled=flag
    }
}

const actions = {
    updateHandled(state,flag){
        state.commit('updateHandled',flag)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}